import { gql } from '__generated__';

export default gql(`
  mutation ToggleParticipantField($input: ToggleParticipantFieldInput!) {
    toggleParticipantField(input: $input) {
      id
      enabled
    }
  }
`);
